module.exports = __webpack_public_path__ + "img/Group 97987.432d85c5.png";